/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_ContractConcreteRecipe,
  ListCommandResult_ContractConcreteRecipe
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TContractConcreteRecipeType,
  TNonEmptyArray,
  TJoin,
  TConcreteRecipeType,
  TContractType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TContractConcreteRecipeType
  | TJoin<"contract", TContractType>
  | TJoin<"concreteRecipe", TConcreteRecipeType>;

type TContractConcreteRecipeByIdFunctions = {
  getByID: CommandResult_ContractConcreteRecipe;
};
export type TContractConcreteRecipeByIdQueries = {
  contractConcreteRecipe: TContractConcreteRecipeByIdFunctions;
};

export const contractConcreteRecipeById = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractConcreteRecipeById($id: Guid!) {
    contractConcreteRecipe {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ContractConcreteRecipe")}
`;

type TContractConcreteRecipeAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_ContractConcreteRecipe;
};
export type TContractConcreteRecipeAllWithPaginationQueries = {
  contractConcreteRecipe: TContractConcreteRecipeAllWithPaginationFunctions;
};
export const contractConcreteRecipeAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractConcreteRecipeAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    contractConcreteRecipe {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ContractConcreteRecipe")}
`;
